export default class Option{
    id:number;
    name:string;
    roleName:string;

    constructor(id:number|null = null, name:string|null = null, roleName:string|null = null) {
        this.id = id ?? -1;
        this.name = name ?? "";
        this.roleName = roleName ?? "";
    }
}